var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "view-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M0,0H20V20H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M10.2,3a9.17,9.17,0,0,1,9.016,7.5,9.169,9.169,0,0,1-18.032,0A9.17,9.17,0,0,1,10.2,3Zm0,13.333A7.5,7.5,0,0,0,17.511,10.5a7.5,7.5,0,0,0-14.628,0A7.5,7.5,0,0,0,10.2,16.333Zm0-2.083a3.75,3.75,0,1,1,3.75-3.75A3.75,3.75,0,0,1,10.2,14.25Zm0-1.667A2.083,2.083,0,1,0,8.113,10.5,2.083,2.083,0,0,0,10.2,12.583Z",
    transform: "translate(-0.197 -0.5)",
    fill: "#7aba56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.df63cecc3e2425a8b3e5366f411cea24.svg";
export { ForwardRef as ReactComponent };